/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Maybe_LaterInputs */

const en_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maybe Later`)
};

const ar_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ربما لاحقًا`)
};

const de_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vielleicht später`)
};

const es_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más tarde`)
};

const fr_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peut-être plus tard`)
};

const it_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forse più tardi`)
};

const ja_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あとで`)
};

const ko_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`나중에`)
};

const pt_br_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talvez mais tarde`)
};

const ru_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возможно, позже`)
};

const th_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไว้ภายหลัง`)
};

const tr_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belki Sonra`)
};

const zh_cn_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稍后再说`)
};

const zh_tw_btn_maybe_later = /** @type {(inputs: Btn_Maybe_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`稍後再說`)
};

/**
* | output |
* | --- |
* | "Maybe Later" |
*
* @param {Btn_Maybe_LaterInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const btn_maybe_later = /** @type {((inputs?: Btn_Maybe_LaterInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Maybe_LaterInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_btn_maybe_later(inputs)
	if (locale === "ar") return ar_btn_maybe_later(inputs)
	if (locale === "de") return de_btn_maybe_later(inputs)
	if (locale === "es") return es_btn_maybe_later(inputs)
	if (locale === "fr") return fr_btn_maybe_later(inputs)
	if (locale === "it") return it_btn_maybe_later(inputs)
	if (locale === "ja") return ja_btn_maybe_later(inputs)
	if (locale === "ko") return ko_btn_maybe_later(inputs)
	if (locale === "pt_br") return pt_br_btn_maybe_later(inputs)
	if (locale === "ru") return ru_btn_maybe_later(inputs)
	if (locale === "th") return th_btn_maybe_later(inputs)
	if (locale === "tr") return tr_btn_maybe_later(inputs)
	if (locale === "zh_cn") return zh_cn_btn_maybe_later(inputs)
	return zh_tw_btn_maybe_later(inputs)
});